import {useMemo} from 'react'

import {usePlant} from './usePlant'

export const usePlantKilnIds: () => string[] = () => {
  const plant = usePlant()
  return useMemo(() => plant?.kilnIds ?? [], [plant?.kilnIds])
}
